
import { EventsStringService } from "src/app/shared/services/events-string.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BLOCKLY_LABEL_PROPERTES, BlocklyToolboxCategory, PROPERTIES_FOR_EVENTS } from "../blocky-types.types";

export function BlocklyCategory_VIEW_FUSION_YOUTUBE(name: string = "unnamed", BH: BlocklyHelperService, eventStringService: EventsStringService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [] };
  const secondsArray = Array.from({ length: 60 }, (_, i) => i.toString());
  const volumeArray = Array.from({ length: 101 }, (_, i) => i.toString());
  const timeSelectors = "{{hh:dropdown=0,1,2,3}}:{{mm:dropdown=" + secondsArray.join(',') + " }}:{{ss:dropdown=" + secondsArray.join(',') + "}}";

  cat.contents = [
    BH.label("Bot-Ansichten -> " + name),
    BH.action("YOUTUBE_GO_TO", "Springe zu (" + timeSelectors + ")", "await RAGAI.YOUTUBE.seekTo({{hh}},{{mm}},{{ss}}); "),
    BH.action("YOUTUBE_SPEED", "Wiedergabe geschwindigkeit: {{speed:dropdown=0.25,0.5,0.75,1,1.5,1.25,1.75,2}}", "await RAGAI.YOUTUBE.setPlaybackRate({{speed}});"),
    BH.action("YOUTUBE_VOLUME", "Lautstärke: {{speed:dropdown=" + volumeArray.join(',') + "}}", "await RAGAI.YOUTUBE.setVolume({{speed}});"),
    BH.actionDropdown("YOUTUBE_ACTIONS", "Youtube", [
      ["Play()", "await RAGAI.YOUTUBE.play();"],
      ["Pause()", "await RAGAI.YOUTUBE.pause();"],
      ["Stop()", "await RAGAI.YOUTUBE.stop();"],
      ["Mute()", "await RAGAI.YOUTUBE.mute();"],
      ["Unmute()", "await RAGAI.YOUTUBE.unmute();"]
    ]),
    BH.withNested(
      BH.action("YOUTUBE_LOAD_VIDEO", "Youtube Video Laden: {{value}}\nStart in Sec: {{ start }}\nEnde in Sec: {{ end }}", "await RAGAI.YOUTUBE.loadVideo({{value}}, {{start}}, {{end}});", true),
      [
        { forValue: 'value', isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: 'start', isShadow: true, targetBlockType: BLOCKLY_DUMMY.SECONDS },
        { forValue: 'end', isShadow: true, targetBlockType: BLOCKLY_DUMMY.SECONDS }
      ]
    ),
    { kind: 'label', text: 'Ereignisse' },
    BH.withNested(
      BH._custom("YOUTUBE_EVENT_ON_TIME_HOOK", "bei Youtube:\nEreignis-ID: {{?eventId}}\nPlayer-Zeit: {{mode:dropdown=nach|>,vor|<,genau|==}} (" + timeSelectors + ")\n{{action:statement[@check=ACTION]}} {{callonce:checkbox}} Einmalig ausführen",
        `RAGAI.VARIABLES[{{eventId}}] = RAGAI.EVENTS.on('RAGAI.YOUTUBE.playpositionchanged',
        async function(){\n\t if(RAGAI.YOUTUBE.youtube.currentPlayPosition {{mode}} RAGAI.HELPER.timeToSeconds({{hh}},{{mm}},{{ss}}) ) {
          {{action}}
          if({{callonce}}){
            RAGAI.EVENTS.off(RAGAI.VARIABLES[{{eventId}}]);
            delete RAGAI.VARIABLES[{{eventId}}];
          }
        }
    });`,
        PROPERTIES_FOR_EVENTS),
      [{ forValue: "eventId", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
    ),
    BLOCKLY_LABEL_PROPERTES,
    BH.propertyDropdown(
      "YOUTUBE_PROPERITES",
      "Youtube",
      [
        ["position", "window.RAGAI.YOUTUBE.youtube.currentPlayPosition"],
        ["state", "RAGAI.YOUTUBE.currentState"]
      ]),
    BH.eventDropdown("YOUTUBE_EVENTS", eventStringService.get("RAGAI.YOUTUBE.")),
    BH.eventDropdown("YOUTUBE_EVENTS_RAW", eventStringService.getRaw("RAGAI.YOUTUBE."))
  ];
  cat.contents.push();
  return cat;
}
